/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
require('components/common/search-tool/search-tool');
require('components/base/input-box/input-box');
require('components/base/btn/btn');
require('components/base/loading/loading');
require('components/common/date-time/date-time')

const store = require('appVuex/store');
const tip = require('components/base/pop/tip');
const confirm = require('components/base/pop/confirm');

const { getCityList : cityList } = require('appVuex/getter/common')
const { apiPath } = require('appService/api');

const ajaxHttp = require('appUtil/ajaxHttp.js')
const configPushMixin = require('../../mixin')

require('./message-push-list.scss');
const template = require('./message-push-list.tpl');

const appPopUpList = {
  name: "message-push-list",

  template,

  data() {
    return {
      thItems: ["序号", "标题", "用户ID", "用户名", "用户手机号", "内容", "操作人", "发送日期",  "状态", "操作"],
      usersList: [
        { 'value':-1, 'text': '选择用户类型'},
        { 'value':0, 'text': '所有用户'},
        { 'value':1, 'text': '具体用户'}
      ],
      url: apiPath.configPush.messagePush.list,
      queryOpt: {},
      startTimeInput: "",
      inputDisplay: false
    }
  },

  mixins: [configPushMixin],

  filters: {
    statusFilter(val) {
      switch (val) {
        case 0: return '未发送';
        case 1: return '已发送';
        case 2: return '已撤回';
        default: return '--'
      }
    }
  },

  watch: {
    cityList(val) {
      this.$refs.tableData.fetch()
    }
  },

  methods: {
    fetchQuery({queryValue}) {
      console.log(queryValue)
      let {userInputboxOperator, userInputboxTitle, userInputboxUser} = this.$refs
      this.$refs.tableData.query(queryValue).fetch()
    },

    offLine(id) {
      let self = this

      confirm({
        message: '确定撤回该消息吗？',
        cb(confirm) {
          confirm.hide()

          ajaxHttp(apiPath.configPush.messagePush.offline, {
            data: {
              id: id
            }
          }).then((rtn) => {
            self.$refs.tableData.fetch()

            tip('撤回成功！')
          }).catch((rtn) => {
            tip(rtn.error)
          })
        }
      })
    },

    offlineDisplay(status) {
      return status != 2
    }
  }
}

module.exports = appPopUpList;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/configPush/message-push/message-push-list/message-push-list.js